<section id="wrapper" class="container content-wrapper">
    <article>
        <div class="row">
            <div class="col-xs-12">
                <h1 class="headline">Sitemap</h1>
                <div class="row">
                    <div class="col-md-6">
                        <h3 class="text-center my-4">Search for Weather:</h3>
                        <form
                                [formGroup]="weatherSearchForm"
                                (ngSubmit)="sendToAPIXU(weatherSearchForm.value)"
                        >
                            <div class="form-group">
                                <input
                                        class="form-control"
                                        type="text"
                                        id="weatherLocation"
                                        aria-describedby="weatherLocation"
                                        placeholder="Please input a Location"
                                        formControlName="location"
                                />
                            </div>
                            <div class="text-center">
                                <button type="submit" class="btn btn-success btn-md">
                                    Search for the weather
                                </button>
                            </div>
                        </form>
                        <pre>{{this.weatherData | json}}</pre>
                    </div>
                    <div class="col-md-6">
                        <h3 class="text-center my-4">Weather Details:</h3>
                        {{ this.weatherData?.location.name}}
                        {{ this.weatherData?.location.localtime}}
                        <p class="text-center">
                            Current weather conditions: {{ this.weatherData?.current.observation_time}}.
                        </p>
                        <p class="text-center">
                            Temperature in Degrees Celsius: {{ this.weatherData?.current.temperature}}
                        </p>
                        <p class="text-center">
                            <img src="{{ this.weatherData?.current.weather_icons }}" />
                        </p>
                        <p class="text-center">
                            Feels like in Degrees Celsius: {{ this.weatherData?.current.feelslike_c
                            }}
                        </p>
                        <p class="text-center">
                            Feels like in Degrees Farenheit: {{
                            this.weatherData?.current.feelslike_f }}
                        </p>
                        <p class="text-center">
                            Location Searched: {{ this.weatherData?.location.name }}, {{
                            this.weatherData?.location.country }}.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </article>
</section>

